<template>
  <div class="layout-default">
    <header class="layout-default__header">
      <div class="layout-default__header__container">
        <h1 class="layout-default__header__logo">
          <PlayLogoHorizontalSvg />
        </h1>

        <ul class="ml-auto flex">
          <li class="mr-8" v-for="section in returnMenu" :key="section.title">
            <router-link active-class="active" class="ml-auto" :to="{name: section.route}"><h2>{{ section.title }}</h2></router-link>
          </li>
           <li
            v-if="userProfile"
          >
            <a
              href="#"
              @click.prevent="signOut"
            >
              Logout
            </a>
          </li>
        </ul>
      </div>
    </header>

    <main class="layout-default__main">
      <h2 class="layout-default__main__page-heading">

        {{ returnSection }}

        <div
          class="layout-default__main__page-heading__loading"
          v-if="isLoading"
        >
          <FontAwesomeIcon
            icon="circle-notch"
            spin
          />
        </div>
      </h2>

      <div class="layout-default__main__page-content">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'LoggedView',

  data () {
    return {
      menu: [
        {
          title: 'Videos',
          route: 'loggedVideos'
        },
        {
          title: 'Livros',
          route: 'loggedBooks'
        },
        {
          title: 'Usuários',
          route: 'loggedUsers',
          roles: ['ADMIN']
        }
      ]
    }
  },

  computed: {
    ...mapState('global', ['isLoading']),
    ...mapState('auth', ['userProfile']),
    returnSection () {
      let v = ''
      for (const i of this.menu) {
        if (i.route === this.$route.name) {
          v = i.title
        }
      }
      return v
    },
    returnMenu () {
      const arr = []
      for (const link of this.menu) {
        if (this.checkRoles(link)) {
          arr.push(link)
        }
      }
      return arr
    }
  },

  methods: {
    ...mapMutations('auth', [
      'SET_IS_SIGN_IN',
      'SET_USER_PROFILE'
    ]),

    signOut () {
      this.SET_IS_SIGN_IN(false)
      this.SET_USER_PROFILE(null)

      this.$router.push({ name: 'login' })
    },

    checkRoles (s) {
      if (s.roles) {
        return this.userProfile.roles.includes('ADMIN')
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  a {
    @apply text-white;
    @apply border-b-2;
    @apply border-white;
    @apply pb-1;
    &.active {
      @apply font-bold;
      @apply border-solid;
    }
  }
}
</style>
